import React from "react";
import { AppBar, Divider, IconButton, Toolbar } from "@mui/material";
import { Email, LinkedIn } from "@mui/icons-material";

import { Logo } from "src/shared/ui";
import { LocaleSwitcher } from "src/features";

import { Navbar } from "./Navbar/Navbar";

export const Header: React.FC = () => {
  return (
    <AppBar
      component="nav"
      position="sticky"
      sx={{
        backgroundColor: `background.paper`,
      }}
    >
      <Toolbar disableGutters>
        <Logo />
        <Navbar />
        <Divider
          orientation="vertical"
          sx={{
            display: { md: "flex", xs: "none" },
            height: 36,
            borderColor: "text.primary",
          }}
        />

        <IconButton
          component="a"
          href="https://www.linkedin.com/in/sven-badalyan/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Sven Badalyan on LinkedIn"
          color="primary"
          sx={{
            marginLeft: "10px",
            order: { md: "initial", xs: 2 },
            minWidth: 44,
            minHeight: 44,
          }}
        >
          <LinkedIn />
        </IconButton>

        <IconButton
          component="a"
          href="mailto:contact@svenbadalyan.com"
          aria-label="Email Sven Badalyan"
          color="primary"
          sx={{
            order: { md: "initial", xs: 3 },
            minWidth: 44,
            minHeight: 44,
          }}
        >
          <Email />
        </IconButton>

        <LocaleSwitcher />
      </Toolbar>
    </AppBar>
  );
};
